module.exports = __webpack_public_path__ + "media/images/get-involved/cas-43f674166eb1ac57f6d42a8c88c13437.svg";